const CHARS_CODE = {
  a: 97,
  z: 122,
  underscore: 95,
  hyphen: 45,
  zero: 48,
  nine: 57,
};

const isSmallLetter = (name: string, index: number) =>
  name.charCodeAt(index) >= CHARS_CODE.a &&
  name.charCodeAt(index) <= CHARS_CODE.z;

const isNumber = (name: string, index: number) =>
  name.charCodeAt(index) >= CHARS_CODE.zero &&
  name.charCodeAt(index) <= CHARS_CODE.nine;

const isUnderscoreOrHyphen = (name: string, index: number) =>
  name.charCodeAt(index) === CHARS_CODE.underscore ||
  name.charCodeAt(index) === CHARS_CODE.hyphen;

const isValidName = (name: string, pos: number) => {
  const fragment = name.substring(pos - 2, pos + 3);

  return fragment.match(/[a-z]_[a-z]/) || fragment.match(/[a-z]-[a-z]/);
};

const isValidNumber = (name: string, pos: number) => {
  const VALID_LENGTH = 2;
  const INVALID_NUMBER = 0;
  const number = name.substring(pos);

  return (
    number.length <= VALID_LENGTH &&
    Number(number[0]) > INVALID_NUMBER &&
    parseInt(number, 10)
  );
};

export const isValidEPAMEmail = (email: string) => {
  const name = email.substring(0, email.indexOf('@epam.com'));

  if (!name.match(/[a-z]_[a-z]/)) {
    return false;
  }

  if (!isSmallLetter(name, 0)) {
    return false;
  }

  for (let i = 1; i < name.length; i++) {
    if (isUnderscoreOrHyphen(name, i)) {
      if (!isValidName(name, i)) {
        return false;
      }

      i++;
    }

    if (isNumber(name, i)) {
      if (!isValidNumber(name, i)) {
        return false;
      }

      break;
    }

    if (!isSmallLetter(name, i)) {
      return false;
    }
  }

  return true;
};
